import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@classes/user';
// import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UiService } from './ui.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  environment = this.envConfigurationService.environment;

  currentUser = new BehaviorSubject<User | null>(null);

  private basePath = this.environment.apiUrl + '/account';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
    // public uiService: UiService
  ) { }

  getCurrentUser(): Observable<boolean> {
    if (this.currentUser.value !== null) {
      return of(true);
    }
    // this.uiService.addRouteLoading();
    return this.http.get<User>(this.basePath + '/getAccount').pipe(
      tap(user => {
        this.currentUser.next(new User(user));
        // this.uiService.removeRouteLoading()
      }, error => {
        // this.uiService.removeRouteLoading()
      }),
      map(() => true));
  }

  getNotificationCount(): Observable<Array<number>> {
    return this.http.get<Array<number>>(this.basePath + '/notificationcount')
  }
}
